var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":_vm.downloadPdf}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("fa-download")])],1)]}}])},[_c('span',[_vm._v("Download")])])}
var staticRenderFns = []

export { render, staticRenderFns }